import React, { useEffect, lazy, Suspense } from 'react';
import steps from './survey/steps';
import setupSurvey from './survey/setupSurvey';
import getParameterFromURL from './utils/scripts/getParameterFromURL';
import { getPageUrlValue, determinePaymentVersion } from './utils/scripts/analyticsTags';
import useAppLifecycle from './hooks/useAppLifecycle';
import Steps from './pages/steps';
import s from './app.module.scss';
import { useAppStore } from './store';

// Loader показывается только в самом конце воронки — не тянем его в главный бандл.
const Loader = lazy(() => import('./components/loader'));

export default function App() {
  const showSteps = useAppStore((state) => state.showSteps);
  const showLoader = useAppStore((state) => state.showLoader);
  const onbordingVersion = getParameterFromURL('config') ? getParameterFromURL('config') : '';

  useAppLifecycle();

  useEffect(() => {
    // Idempotent: no-op when the pre-render hydration path already set the engine up.
    setupSurvey();
  }, []);

  useEffect(() => {
    if (!window.loadEvent) {
      const pageUrlValue = getPageUrlValue();
      const paymentVersion = determinePaymentVersion();

      // Какой HTML отдал nginx и как он загрузился (см. prerenderShell.ts):
      // prerender — гидрация статичного первого экрана;
      // prerender_fallback — pre-render файл, но откат на классический SPA-boot;
      // spa — обычный build/index.html (для конфига нет pre-render файла).
      let pageType = 'spa';
      if (window.prerenderBoot === 'hydrate') pageType = 'prerender';
      if (window.prerenderBoot === 'fallback') pageType = 'prerender_fallback';

      window.loadEvent = true;
      steps.analytics.send({
        event: {
          event: 'onboarding_question',
          quiz_question: 'page_load',
          quiz_answer: pageUrlValue,
          payment_type: paymentVersion,
          page_type: pageType,
          link: `${pageUrlValue}${paymentVersion}`,
        },
      });
      localStorage.setItem('link', `${pageUrlValue}${paymentVersion}`);
    }
  }, []);

  return (
    <div className={`${s.app} ${onbordingVersion} application`}>
      {showSteps && !showLoader && <Steps />}
      {showLoader && (
        <Suspense fallback={null}>
          <Loader />
        </Suspense>
      )}
    </div>
  );
}
